<template>
  <div class="google-login-wrapper">
    <div ref="googleAuthButton" />
  </div>
</template>

<script>
import config from "@/config.js";
import googleAuth from "@/services/googleAuth";

export default {
  data() {
    return {
      hover: false,
    };
  },
  props: {
    params: {
      type: Object,
      default: () => ({ clientId: config.GOOGLE_AUTH_CLIENT_ID }),
    },
  },
  mounted() {
    this.initGoogleAuth();
  },
  computed: {
    iconName() {
      return this.hover ? "google-logo-white" : "google-logo";
    },
  },
  methods: {
    async authenticate() {
      try {
        await googleAuth.login();
      } catch (error) {
        console.log(error)
      }
    },
    async initGoogleAuth() {
      await googleAuth.load({ ...this.params, callback: this.handleCredentialResponse });
      window.google.accounts.id.renderButton(this.$refs.googleAuthButton, {
        size: 'large',
        width: '335',
        theme: 'filled_blue',
        logo_alignment: 'left',
        locale: 'en'
      });
    },
    async handleCredentialResponse(response) {
      if (response.credential) {
        this.$emit("success", { ...response });
      } else {
        this.$emit("failure", { ...response });
      }
    }
  },
};
</script>

<style scoped>
.google-login-wrapper {
  height: 46px;
}
</style>
